var _mask, _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEliteMob({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 52,
    viewBox: "0 0 158 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_30_48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 38C0 30.268 6.26801 24 14 24H144C151.732 24 158 30.268 158 38V38C158 45.732 151.732 52 144 52H14C6.26802 52 0 45.732 0 38V38Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 38C0 30.268 6.26801 24 14 24H144C151.732 24 158 30.268 158 38V38C158 45.732 151.732 52 144 52H14C6.26802 52 0 45.732 0 38V38Z",
    fill: "url(#paint0_linear_30_48)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 25H144V23H14V25ZM144 51H14V53H144V51ZM14 51C6.8203 51 1 45.1797 1 38H-1C-1 46.2843 5.71573 53 14 53V51ZM157 38C157 45.1797 151.18 51 144 51V53C152.284 53 159 46.2843 159 38H157ZM144 25C151.18 25 157 30.8203 157 38H159C159 29.7157 152.284 23 144 23V25ZM14 23C5.71573 23 -1 29.7157 -1 38H1C1 30.8203 6.8203 25 14 25V23Z",
    fill: "url(#paint1_linear_30_48)",
    fillOpacity: 0.35,
    mask: "url(#path-1-inside-1_30_48)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.71 34.46C11.71 33.848 11.626 33.398 11.458 33.11C11.29 32.81 10.954 32.66 10.45 32.66H10.27V32.12H18.208C19.228 32.12 19.738 32.6 19.738 33.56V35.09H19.198C19.198 34.346 19.006 33.8 18.622 33.452C18.25 33.104 17.692 32.93 16.948 32.93H14.05V37.43H18.73V38.24H14.05V43.19H17.128C17.812 43.19 18.382 43.04 18.838 42.74C19.294 42.428 19.672 41.894 19.972 41.138L20.458 41.318L19.936 42.74C19.78 43.172 19.594 43.49 19.378 43.694C19.162 43.898 18.826 44 18.37 44H11.71V34.46ZM22.503 34.46C22.503 33.848 22.419 33.398 22.251 33.11C22.083 32.81 21.747 32.66 21.243 32.66H21.063V32.12H23.223C23.655 32.12 23.985 32.192 24.213 32.336C24.441 32.48 24.603 32.72 24.699 33.056C24.795 33.38 24.843 33.848 24.843 34.46V43.19H31.053V44H22.503V34.46ZM33.8721 44C33.4401 44 33.1101 43.934 32.8821 43.802C32.6541 43.658 32.4921 43.424 32.3961 43.1C32.3001 42.764 32.2521 42.284 32.2521 41.66V32.12H34.5921V41.66C34.5921 42.272 34.6761 42.728 34.8441 43.028C35.0121 43.316 35.3481 43.46 35.8521 43.46H36.0321V44H33.8721ZM40.4729 32.93H39.1949C38.5229 32.93 38.0069 33.098 37.6469 33.434C37.2989 33.77 37.1249 34.322 37.1249 35.09H36.5849V33.56C36.5849 32.6 37.0949 32.12 38.1149 32.12H46.5749V32.93H42.8129V44H40.4729V32.93ZM48.3604 34.46C48.3604 33.848 48.2764 33.398 48.1084 33.11C47.9404 32.81 47.6044 32.66 47.1004 32.66H46.9204V32.12H54.8584C55.8784 32.12 56.3884 32.6 56.3884 33.56V35.09H55.8484C55.8484 34.346 55.6564 33.8 55.2724 33.452C54.9004 33.104 54.3424 32.93 53.5984 32.93H50.7004V37.43H55.3804V38.24H50.7004V43.19H53.7784C54.4624 43.19 55.0324 43.04 55.4884 42.74C55.9444 42.428 56.3224 41.894 56.6224 41.138L57.1084 41.318L56.5864 42.74C56.4304 43.172 56.2444 43.49 56.0284 43.694C55.8124 43.898 55.4764 44 55.0204 44H48.3604V34.46Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.71 34.46C102.71 33.848 102.626 33.398 102.458 33.11C102.29 32.81 101.954 32.66 101.45 32.66H101.27V32.12H103.43C103.862 32.12 104.192 32.192 104.42 32.336C104.648 32.48 104.81 32.72 104.906 33.056C105.002 33.38 105.05 33.848 105.05 34.46V43.19H111.26V44H102.71V34.46ZM122.57 44.072C121.814 44.072 121.13 43.916 120.518 43.604C119.906 43.28 119.408 42.656 119.024 41.732L118.61 40.724H113.822L112.346 44H111.41L116.72 32.12H117.53L121.562 41.732C122.018 42.848 122.642 43.448 123.434 43.532V43.982C123.218 44.042 122.93 44.072 122.57 44.072ZM114.2 39.914H118.268L116.288 35.216L114.2 39.914ZM124.63 34.46C124.63 33.848 124.546 33.398 124.378 33.11C124.21 32.81 123.874 32.66 123.37 32.66H123.19V32.12H128.086C130.51 32.12 132.352 32.636 133.612 33.668C134.884 34.688 135.52 36.128 135.52 37.988C135.52 39.176 135.25 40.226 134.71 41.138C134.182 42.038 133.39 42.74 132.334 43.244C131.29 43.748 130.03 44 128.554 44H124.63V34.46ZM128.5 43.28C129.34 43.28 130.084 43.07 130.732 42.65C131.392 42.23 131.902 41.624 132.262 40.832C132.634 40.04 132.82 39.116 132.82 38.06C132.82 37.016 132.634 36.104 132.262 35.324C131.902 34.532 131.392 33.92 130.732 33.488C130.072 33.056 129.316 32.84 128.464 32.84H128.32C127.924 32.84 127.606 32.864 127.366 32.912L126.97 32.966V43.154L127.366 43.226C127.618 43.262 127.936 43.28 128.32 43.28H128.5ZM140.545 39.248L137.359 34.46C136.999 33.944 136.603 33.494 136.171 33.11C135.751 32.726 135.349 32.516 134.965 32.48V32.12H136.927C137.539 32.12 138.091 32.312 138.583 32.696C139.087 33.08 139.513 33.548 139.861 34.1L142.309 37.79L145.801 32.12H146.971L142.885 38.762V44H140.545V39.248Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_30_48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_30_48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79 9C80.6569 9 82 7.65685 82 6C82 4.34315 80.6569 3 79 3C77.3431 3 76 4.34315 76 6C76 7.65685 77.3431 9 79 9ZM73 25.5L79 13L85 25.5L99 20L94.5 34.5L79 43L63.5 34.5L59 20L73 25.5ZM106 16C106 17.6569 104.657 19 103 19C101.343 19 100 17.6569 100 16C100 14.3431 101.343 13 103 13C104.657 13 106 14.3431 106 16ZM55 19C56.6569 19 58 17.6569 58 16C58 14.3431 56.6569 13 55 13C53.3431 13 52 14.3431 52 16C52 17.6569 53.3431 19 55 19Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79 9C80.6569 9 82 7.65685 82 6C82 4.34315 80.6569 3 79 3C77.3431 3 76 4.34315 76 6C76 7.65685 77.3431 9 79 9ZM73 25.5L79 13L85 25.5L99 20L94.5 34.5L79 43L63.5 34.5L59 20L73 25.5ZM106 16C106 17.6569 104.657 19 103 19C101.343 19 100 17.6569 100 16C100 14.3431 101.343 13 103 13C104.657 13 106 14.3431 106 16ZM55 19C56.6569 19 58 17.6569 58 16C58 14.3431 56.6569 13 55 13C53.3431 13 52 14.3431 52 16C52 17.6569 53.3431 19 55 19Z",
    fill: "url(#paint2_linear_30_48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 13L79.9015 12.5673L79 10.6891L78.0985 12.5673L79 13ZM73 25.5L72.6343 26.4308L73.4994 26.7706L73.9015 25.9327L73 25.5ZM85 25.5L84.0985 25.9327L84.5006 26.7706L85.3657 26.4308L85 25.5ZM99 20L99.9551 20.2964L100.572 18.308L98.6343 19.0692L99 20ZM94.5 34.5L94.9808 35.3768L95.3353 35.1825L95.4551 34.7964L94.5 34.5ZM79 43L78.5192 43.8768L79 44.1405L79.4808 43.8768L79 43ZM63.5 34.5L62.5449 34.7964L62.6647 35.1825L63.0192 35.3768L63.5 34.5ZM59 20L59.3657 19.0692L57.4278 18.308L58.0449 20.2964L59 20ZM81 6C81 7.10457 80.1046 8 79 8V10C81.2091 10 83 8.20914 83 6H81ZM79 4C80.1046 4 81 4.89543 81 6H83C83 3.79086 81.2091 2 79 2V4ZM77 6C77 4.89543 77.8954 4 79 4V2C76.7909 2 75 3.79086 75 6H77ZM79 8C77.8954 8 77 7.10457 77 6H75C75 8.20914 76.7909 10 79 10V8ZM78.0985 12.5673L72.0985 25.0673L73.9015 25.9327L79.9015 13.4327L78.0985 12.5673ZM85.9015 25.0673L79.9015 12.5673L78.0985 13.4327L84.0985 25.9327L85.9015 25.0673ZM98.6343 19.0692L84.6343 24.5692L85.3657 26.4308L99.3657 20.9308L98.6343 19.0692ZM95.4551 34.7964L99.9551 20.2964L98.0449 19.7036L93.5449 34.2036L95.4551 34.7964ZM79.4808 43.8768L94.9808 35.3768L94.0192 33.6232L78.5192 42.1232L79.4808 43.8768ZM63.0192 35.3768L78.5192 43.8768L79.4808 42.1232L63.9808 33.6232L63.0192 35.3768ZM58.0449 20.2964L62.5449 34.7964L64.4551 34.2036L59.9551 19.7036L58.0449 20.2964ZM73.3657 24.5692L59.3657 19.0692L58.6343 20.9308L72.6343 26.4308L73.3657 24.5692ZM103 20C105.209 20 107 18.2091 107 16H105C105 17.1046 104.105 18 103 18V20ZM99 16C99 18.2091 100.791 20 103 20V18C101.895 18 101 17.1046 101 16H99ZM103 12C100.791 12 99 13.7909 99 16H101C101 14.8954 101.895 14 103 14V12ZM107 16C107 13.7909 105.209 12 103 12V14C104.105 14 105 14.8954 105 16H107ZM57 16C57 17.1046 56.1046 18 55 18V20C57.2091 20 59 18.2091 59 16H57ZM55 14C56.1046 14 57 14.8954 57 16H59C59 13.7909 57.2091 12 55 12V14ZM53 16C53 14.8954 53.8954 14 55 14V12C52.7909 12 51 13.7909 51 16H53ZM55 18C53.8954 18 53 17.1046 53 16H51C51 18.2091 52.7909 20 55 20V18Z",
    fill: "url(#paint3_linear_30_48)",
    fillOpacity: 0.35,
    mask: "url(#path-5-inside-2_30_48)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_30_48",
    x: 46,
    y: 0,
    width: 66,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_30_48"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_48",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_48",
    x1: 0.00000281102,
    y1: 56.375,
    x2: 162.015,
    y2: 9.60666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A87F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180201,
    stopColor: "#A87F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409876,
    stopColor: "#FFDC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597465,
    stopColor: "#FFDC62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758671,
    stopColor: "#A87F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A87F35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_48",
    x1: 79,
    y1: 24,
    x2: 79,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#BD9457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E3CA89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#FEE8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#4D3A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF0D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_30_48",
    x1: 60.259,
    y1: 55.5,
    x2: 104.46,
    y2: 45.4441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A87F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.180201,
    stopColor: "#A87F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409876,
    stopColor: "#FFD74D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597465,
    stopColor: "#FFDD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758671,
    stopColor: "#A87F35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A87F35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_30_48",
    x1: 79,
    y1: 3,
    x2: 79,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF6D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#BD9457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E3CA89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#FEE8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#4D3A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF0D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliteMob);
export default __webpack_public_path__ + "static/media/elite-mob.990844fe55e6c3b004abab781ea08ced.svg";
export { ForwardRef as ReactComponent };